export default {"src":"/_next/static/media/tailwind.f4af2906.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};